export const Runner = ({ width, height }: { width?: string; height?: string }) => {
	return (
		<svg
			style={{ width: width ?? 'clamp(13px, 4vw, 15px)', height: height ?? 'auto' }}
			viewBox='0 0 15 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7.56557 14.1113V10.778L6.3989 9.66688L5.84334 12.1113L2.01001 11.3336L2.23223 10.2224L4.8989 10.778L5.78779 6.27799L4.78779 6.66688V8.55577H3.67668V5.94466L5.87112 5.00022C6.1952 4.86133 6.43362 4.77105 6.5864 4.72938C6.73918 4.68772 6.88038 4.66688 7.01001 4.66688C7.20445 4.66688 7.38501 4.71781 7.55168 4.81966C7.71834 4.92151 7.8526 5.05577 7.95445 5.22244L8.51001 6.11133C8.75075 6.50022 9.07714 6.81966 9.48918 7.06966C9.90121 7.31966 10.3711 7.44466 10.8989 7.44466V8.55577C10.2878 8.55577 9.71603 8.42846 9.18362 8.17383C8.65121 7.9192 8.20445 7.58355 7.84334 7.16688L7.51001 8.83355L8.67668 9.94466V14.1113H7.56557ZM7.84334 4.38911C7.53779 4.38911 7.27621 4.28031 7.05862 4.06272C6.84103 3.84512 6.73223 3.58355 6.73223 3.27799C6.73223 2.97244 6.84103 2.71087 7.05862 2.49327C7.27621 2.27568 7.53779 2.16688 7.84334 2.16688C8.1489 2.16688 8.41047 2.27568 8.62807 2.49327C8.84566 2.71087 8.95445 2.97244 8.95445 3.27799C8.95445 3.58355 8.84566 3.84512 8.62807 4.06272C8.41047 4.28031 8.1489 4.38911 7.84334 4.38911Z'
				fill='#008080'
			/>
		</svg>
	);
};
